// extracted by css-extract-rspack-plugin
export default {"w30":"product-detail-fragment__SkeletonTile_w30__1zz+8"};